module.exports = __webpack_public_path__ + "img/baseline-arrow_downward-24px.7bd8b7e4.svg";